import { Box, Button, IconButton, Switch, Typography } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const RootStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.global.white,
  height: '100%',
}));

export const TitlePageStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.global.gray,
  margin: '30px 96px 40px 96px',
}));

export const SwitchContainerStyled = styled(Box)(({ theme }) => ({
  backgroundColor: alpha(theme.palette.primary.main, 0.3),
  height: 40,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  paddingLeft: 96,
  color: theme.palette.global.gray,
  gap: 6,
}));

export const SwitchStyled = styled(Switch)(({ theme }) => ({
  width: 41,
  height: 21,
  padding: 0,
  borderRadius: 21,
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 16,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(21px)',
      color: alpha(theme.palette.secondary.main, 1),
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor:
          theme.palette.mode === 'dark'
            ? '#177ddc'
            : theme.palette.primary.main,
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 17,
    height: 17,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 8,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255,255,255,.35)'
        : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

export const ContainerDragAndDropAreaStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  margin: '19px 96px',
  '& .paragraphy': {
    marginTop: -12,
  },
});

export const DragAndDropAreaStyled = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  marginBottom: 25,
  gap: 12,
});

export const IconContainerStyled = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  width: 42,
  height: 42,
  borderRadius: 4,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& svg': {
    fontSize: 20,
    color: theme.palette.global.white,
    transition: 'fontSize 0.2s',
    '&:hover': {
      fontSize: 32,
    },
  },
}));

export const DropzoneStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 9,
  height: 42,
  width: '60%',
  border: `1px dashed ${theme.palette.global.lightgray}`,
  borderRadius: 4,
  '&:hover': {
    backgroundColor: alpha(theme.palette.global.lightgray, 0.08),
  },
}));

export const Subtitle2Styled = styled(Typography)(({ theme }) => ({
  color: theme.palette.global.gray,
}));

export const FormStyled = styled('form')(({ theme }) => ({
  backgroundColor: theme.palette.global.white,
  width: '100%',
  padding: '0 96px',
}));

export const PageSectionTitleStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.global.gray,
  marginRight: 25,
  marginBottom: 15,
}));

export const CopyToClipboardStyled = styled(IconButton)(({ theme }) => ({
  color: theme.palette.primary.main,
}));

export const AccordionStyled = styled(Box)({
  width: '100%',
  height: 56,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: '#f2f2f2',
  paddingLeft: 16,
  borderRadius: 4,
  marginTop: 32,
  boxShadow: '2px 2px 2px #ccc',
  cursor: 'pointer',
});

export const AccordionDisableStyled = styled(Box)({
  width: '100%',
  height: 56,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: '#f2f2f2cc',
  paddingLeft: 16,
  borderRadius: 4,
  marginTop: 32,
  boxShadow: '2px 2px 2px #ccc',
  cursor: 'not-allowed',
});

export const SeparatorStyled = styled(Box)({
  display: 'flex',
  width: '100%',
  gap: 13,
  margin: '12px 0',
});

export const BtnAddNewItemsStyled = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.secondary.main,
}));

export const LinksAndTotalStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: 40,
});

export const TotalStyled = styled(Typography)({
  margin: '5px 0',
});

export const ContainerButtonsStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  marginTop: 40,
});

export const BtnSubmitStyled = styled(Button)(({ theme }) => ({
  color: theme.palette.global.white,
  marginRight: 16,
  fontWeight: 600,
  width: 210,
  height: 40,
  marginBottom: 80,
}));
